import AnimatedLayout from 'components/layouts/animated-layout';
import { SettingsContentHeader } from 'components/layouts/settings-workspace/settings-workspace';
import { SettingsDataSection } from 'components/layouts/settings-workspace/settings-data-section';
import HelmetTabComponent from 'components/helmet-tab/helmet-tab';
import { SessionsDatatable } from 'features/profile';

const ActiveSessionsTab = () => {
    return (
        <AnimatedLayout>
            <HelmetTabComponent title="نشست‌های فعال" />

            <SettingsContentHeader
                title="نشست‌های فعال"
                description="ورودهای فعال حساب از روی لاگ‌های احراز هویت نمایش داده می‌شوند. نشست‌های ناشناس را می‌توانید ببندید."
            />

            <SettingsDataSection fullBleed>
                <SessionsDatatable />
            </SettingsDataSection>
        </AnimatedLayout>
    );
};

export default ActiveSessionsTab;
